export default "__VITE_ASSET__382d41f5__"